import React from 'react';

const GenerasiAI: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        <b>Studi Universitas Indonesia 2024</b> mengungkap bahwa <b>65% anak usia 6-12 tahun</b> di Jakarta lebih memilih berbicara dengan <b>chatbot pendidikan</b> daripada bermain dengan teman sebaya. Fenomena &quot;Generasi AI&quot; ini memicu perdebatan sengit di kalangan orang tua dan psikolog.
      </p>

      <div className="bg-blue-50 border-l-4 border-blue-300 p-4 mb-6">
        <p>
          <b>&quot;Mereka bisa menyebutkan nama 10 dinosaur AI assistant, tapi tidak tahu nama tetangga sebelah rumah&quot;</b> - <i>Dr. Siti Rahayu</i>, Psikolog Anak RSJ Cilandak.
        </p>
      </div>

      <h2 className="text-2xl font-bold mb-4">Wajah Baru Teman Bermain</h2>
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        {[
          {
            name: "BudiBot",
            feature: "Asisten PR Matematika",
            stat: "1,2 juta pengguna anak"
          },
          {
            name: "Nina AI",
            feature: "Teman bercerita interaktif",
            stat: "Rating 4,9/5 di PlayStore"
          },
          {
            name: "Kiko the Koala",
            feature: "Pendeteksi emosi anak",
            stat: "Dipakai 500 TK di Indonesia"
          }
        ].map((ai, idx) => (
          <div key={idx} className="border rounded-lg p-3 bg-white">
            <h3 className="font-bold text-lg mb-1">🤖 {ai.name}</h3>
            <p className="text-sm mb-2">{ai.feature}</p>
            <p className="text-xs bg-gray-100 p-1 rounded">{ai.stat}</p>
          </div>
        ))}
      </div>

      <h2 className="text-2xl font-bold mb-4">Dampak Positif yang Tak Terduga</h2>
      <div className="bg-green-50 p-4 rounded-lg mb-6">
        <ul className="list-disc pl-6 space-y-2">
          <li><b>Anak penyendiri</b> menjadi lebih percaya diri berkomunikasi</li>
          <li><b>Kemampuan bahasa Inggris</b> meningkat 40% menurut data Kemendikbud</li>
          <li><b>Minat baca</b> melonjak melalui fitur storytelling AI</li>
          <li>Deteksi dini <b>gangguan perkembangan bicara</b> melalui pola interaksi</li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold mb-4">Kekhawatiran Para Ahli</h2>
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Keterampilan Sosial yang Terhambat</strong></p>
          <p>Anak kesulitan membaca ekspresi wajah dan bahasa tubuh manusia nyata</p>
        </li>
        <li>
          <p><strong>Kecanduan Respons Instan</strong></p>
          <p>Chatbot selalu merespon dengan sempurna, tidak seperti teman sebaya yang kadang menolak</p>
        </li>
        <li>
          <p><strong>Krisis Identitas Digital</strong></p>
          <p>Anak lebih mengenal avatar AI daripada tokoh pahlawan nasional</p>
        </li>
      </ol>

      <div className="flex flex-col md:flex-row gap-6 mb-6">
        <div className="md:w-1/2 bg-yellow-50 p-4 rounded-lg">
          <h3 className="font-bold text-lg mb-3">🔄 Kasus Nyata di Bandung</h3>
          <p>
            <b>Aruna (8 tahun)</b> lebih suka berdiskusi tentang dinosaur dengan AI-nya daripada teman sekolah. Ibunya mencatat:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Prestasi sains meningkat</li>
            <li>Tapi sering bingung saat diajak kerja kelompok</li>
            <li>Cenderung frustasi jika teman tidak sepintar chatbot</li>
          </ul>
        </div>
        <div className="md:w-1/2 bg-purple-50 p-4 rounded-lg">
          <h3 className="font-bold text-lg mb-3">💡 Solusi Seimbang</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Waktu 3-2-1</b>: 3 jam offline, 2 jam belajar dengan AI, 1 jam sosialisasi</li>
            <li><b>AI kelompok</b>: Chatbot yang mendorong kolaborasi antar anak</li>
            <li><b>Orang tua sebagai filter</b>: Memilih konten yang mendorong interaksi sosial</li>
          </ul>
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-4">Respons Pemerintah</h2>
      <p className="mb-4">
        Kementerian PPPA sedang menyusun <b>Panduan Penggunaan AI untuk Anak</b> yang akan mewajibkan:
      </p>
      <ul className="list-disc pl-6 space-y-2 mb-6">
        <li>Peringatan &quot;Ayo bermain dengan teman&quot; setiap 30 menit</li>
        <li>Konten budaya Indonesia wajib 40%</li>
        <li>Fitur deteksi penggunaan berlebihan</li>
      </ul>

      <div className="bg-pink-50 border-l-4 border-pink-300 p-4">
        <h3 className="text-xl font-semibold mb-2">🔮 Masa Depan Hubungan Manusia-AI</h3>
        <p>
          Startup lokal <b>ChildAI</b> sedang mengembangkan asisten hybrid dimana anak harus berinteraksi dengan teman sebaya untuk membuka fitur premium. <i>&quot;Kami ingin teknologi memperkaya, bukan menggantikan hubungan manusia&quot;</i> - kata founder-nya.
        </p>
      </div>

      <p className="mt-6">
        Seperti pisau bermata dua, AI anak bisa menjadi <b>tutor brilian</b> atau <b>teman virtual yang mengisolasi</b>. Tantangannya adalah menemukan titik keseimbangan dimana teknologi memperkuat, bukan melemahkan ikatan sosial alami.
      </p>
    </div>
  );
};

export default GenerasiAI;